import React, { useEffect, useState } from 'react';

import { Grid, Typography, Box, Divider, Chip } from 'core/components/library';
import { DataGridPro as DataGrid, Combo, Text } from 'core/components';
import { SelectedIcon } from 'core/components/icons';
import * as icons from 'core/icons';
import List from 'store/List';
import * as helpers from '../../../../../../core/helpers';

const ComboParcelas = List(Combo, 'options', 'lstparcelasacta');
//const ComboMunicipios = List(Combo, 'options', 'lstmunicipios');
//const ComboVariedades = List(Combo, 'options', 'lstajustevariedades');
const ComboDestinos = List(Combo, 'options', 'lstajustedestinosproduccion');
const ComboMarcos = List(Combo, 'options', 'lstajustemarcosplantacion');
const ComboPortaInjertos = List(Combo, 'options', 'lstajusteportainjertos');
const ComboDerechos = List(Combo, 'options', 'lstajustederechos');
const ComboConducciones = List(Combo, 'options', 'lstajusteconducciones');
const ComboCultivos = List(Combo, 'options', 'lstajustecultivos');
const ComboSistemasExplotacion = List(
    Combo,
    'options',
    'lstajustesistemasexplotacion'
);
const ComboRiegos = List(Combo, 'options', 'lstajustesistemasriego');

const getDesidad = values => {
    let newDensidad = 0;

    if (
        values.marcox &&
        values.marcoy &&
        Number(values.marcox) !== 0 &&
        Number(values.marcoy) !== 0
    ) {
        newDensidad = Math.round(
            10000 / (Number(values.marcox) * Number(values.marcoy))
        );
    }

    return newDensidad;
};

const getModoCultivo = values => {
    let newModoCultivo = null;

    if (values.densidad < 1500 && values.densidad >= 1100) {
        newModoCultivo = { id: 2, descripcion: 'EXTENSIVO', clave: 'E' };
    }

    if (values.densidad > 1900 && values.densidad <= 3350) {
        newModoCultivo = { id: 1, descripcion: 'INTENSIVO', clave: 'I' };
    }

    if (values.densidad < 1100 || values.densidad > 3350) {
        newModoCultivo = { id: 5, descripcion: 'NO DOP', clave: 'N' };
    }

    return newModoCultivo;
};

const getOldValue = (old, values, property, field) => {
    if (old && values) {
        let oldValue =
            field && old[property] ? old[property][field] : old[property];
        let value =
            field && values[property]
                ? values[property][field]
                : values[property];

        if (oldValue === undefined || oldValue === '') oldValue = null;
        if (value === undefined || value === '') value = null;

        if (oldValue !== value) {
            return `antes "${oldValue}"`;
        }
    }

    return null;
};

const cols = (name, row, index, editing, handleChange, refresh, tramite) => [
    {
        key: 'parcela',
        title: 'Parcela',
        align: 'left',
        width: tramite.tipo.traspaso ? '98%' : '35%',
        component: row && (
            <ComboParcelas
                fullWidth
                margin='none'
                variant='standard'
                api={
                    tramite.tipo.acta
                        ? 'parcelas-actas/tramite/' + tramite.id
                        : 'parcelas-tramites/tramite/' + tramite.id
                }
                name={tramite.tipo.acta ? 'parcelaActa' : 'parcelaTramite'}
                nameKey={
                    tramite.tipo.acta ? 'parcelaActaId' : 'parcelaTramiteId'
                }
                refresh={refresh}
                Icon={icons.ParcelIcon}
                value={tramite.tipo.acta ? row.parcelaActa : row.parcelaTramite}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option =>
                    `${option.municipio.descripcion}-${option['poligono']}-${option['parcela']}-${option['recinto']}-${option.variedad.descripcion}-${option['año']}`
                }
            />
        )
    },
    tramite.tipo.traspaso
        ? {
              key: 'ajustar',
              title: '',
              align: 'right',
              width: '2%',
              component: (
                  <Box
                      sx={{
                          display: 'flex',
                          justifyContent: 'center', // centrado horizontal
                          alignItems: 'center', // centrado vertical
                          height: '100%',
                          opacity: 0,
                          transition: 'opacity 0.2s ease-in-out',
                          'tr:hover &': {
                              opacity: 1
                          }
                      }}
                  >
                      <SelectedIcon />
                  </Box>
              )
          }
        : {
              key: 'notas',
              title: 'Notas',
              align: 'left',
              width: '65%',
              component: row && (
                  <Text
                      fullWidth
                      editing={editing}
                      name='notas'
                      variant='standard'
                      margin='none'
                      value={row['notas']}
                      onFocus={event => event.target.select()}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                  />
              )
          }
];

const ParcelaAjustada = props => {
    const { values, parcela, name, index, editing, handleChange, refresh } =
        props;

    useEffect(() => {
        if (editing) {
            handleChange(
                [
                    helpers.getValueControl(
                        'text',
                        'densidad',
                        getDesidad(parcela)
                    )
                ],
                name,
                index
            );
        }
    }, [parcela?.marcox, parcela?.marcoy]);

    useEffect(() => {
        if (editing) {
            handleChange(
                [
                    helpers.getValueControl(
                        'combo',
                        'modoCultivo',
                        getModoCultivo(parcela)
                    )
                ],
                name,
                index
            );
        }
    }, [parcela?.densidad]);

    useEffect(() => {
        if (editing) {
            handleChange(
                [
                    helpers.getValueControl(
                        'text',
                        'arrendatario',
                        parcela.sistemaExplotacion &&
                            parcela.sistemaExplotacion.descripcion ===
                                'Propiedad'
                            ? parcela.tramite.viticultor.nombre
                            : null
                    )
                ],
                name,
                index
            );
        }
    }, [JSON.stringify(parcela?.sistemaExplotacion)]);

    if (!parcela)
        return (
            <Grid container spacing={1}>
                <Grid item xs>
                    <Typography
                        align={'center'}
                        fontWeight={'bold'}
                        variant={'h5'}
                    >
                        No se ha seleccionado ninguna parcela o no necesita
                        ajuste
                    </Typography>
                </Grid>
            </Grid>
        );

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Typography
                        align={'center'}
                        fontWeight={'bold'}
                        variant={'h5'}
                    >
                        {`Parcela: ${parcela.municipio.descripcion}-${parcela.poligono}-${parcela.parcela}-${parcela.recinto}-${parcela.variedad.descripcion}-${parcela.año}`}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item>
                    <Text
                        //helperText={getOldValue(old, values, 'superficie')}
                        fullWidth
                        editing={editing}
                        name='superficie'
                        label='Superficie'
                        type='d.4'
                        value={parcela.superficie}
                        onFocus={event => event.target.select()}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        //helperText={getOldValue(old, values, 'paraje')}
                        fullWidth
                        editing={editing}
                        name='paraje'
                        label='Paraje'
                        value={parcela.paraje}
                        onFocus={event => event.target.select()}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs>
                    <ComboMarcos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'marcoPlantacion',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Tipo Marco'
                        api='auxiliares/marcoplantacion'
                        name='marcoPlantacion'
                        nameKey='marcoPlantacionId'
                        refresh={refresh}
                        value={parcela.marcoPlantacion}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
                <Grid item>
                    <Text
                        //helperText={getOldValue(old, values, 'marcox')}
                        fullWidth
                        editing={editing}
                        name='marcox'
                        label='x (m)'
                        type='d.2'
                        value={parcela.marcox}
                        onFocus={event => event.target.select()}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
                <Grid item>
                    <Text
                        //helperText={getOldValue(old, values, 'marcoy')}
                        fullWidth
                        editing={editing}
                        name='marcoy'
                        label='y (m)'
                        type='d.2'
                        value={parcela.marcoy}
                        onFocus={event => event.target.select()}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
                <Grid item>
                    <Text
                        //helperText={getOldValue(old, values, 'densidad')}
                        fullWidth
                        editing={editing}
                        name='densidad'
                        label='Cepas / ha'
                        type='entero'
                        value={parcela.densidad}
                        onFocus={event => event.target.select()}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
                <Grid item xs>
                    <ComboCultivos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'modoCultivo',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Cultivo'
                        api='auxiliares/modoscultivo'
                        name='modoCultivo'
                        nameKey='modoCultivoId'
                        refresh={refresh}
                        value={parcela.modoCultivo}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs>
                    <ComboPortaInjertos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'portaInjertos',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Porta Injerto'
                        api='auxiliares/portainjertos'
                        name='portaInjertos'
                        nameKey='portaInjertosId'
                        refresh={refresh}
                        value={parcela.portaInjertos}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
                <Grid item xs>
                    <ComboConducciones
                        /*helperText={getOldValue(
                            old,
                            values,
                            'conduccion',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Conducción'
                        api='auxiliares/formasconduccion'
                        name='conduccion'
                        nameKey='conduccionId'
                        refresh={refresh}
                        value={parcela.conduccion}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
                <Grid item xs>
                    <ComboRiegos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'sistemaRiego',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Sistema Riego'
                        api='auxiliares/sistemasriego'
                        name='sistemaRiego'
                        nameKey='sistemaRiegoId'
                        refresh={refresh}
                        value={parcela.sistemaRiego}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
            </Grid>
            <Divider style={{ margin: '12px 12px 12px 12px' }}>
                <Chip label={'Detalles'} />
            </Divider>
            <Grid container spacing={1}>
                <Grid item xs>
                    <ComboSistemasExplotacion
                        /*helperText={getOldValue(
                            old,
                            values,
                            'sistemaExplotacion',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Sistemas Explotación'
                        api='auxiliares/sistemasexplotacion'
                        name='sistemaExplotacion'
                        nameKey='sistemaExplotacionId'
                        refresh={refresh}
                        value={parcela.sistemaExplotacion}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Text
                        //helperText={getOldValue(old, values, 'arrendatario')}
                        fullWidth
                        editing={editing}
                        name='arrendatario'
                        label='Propietario / Arrendador'
                        //variant='standard'
                        //margin='none'
                        type='text'
                        value={parcela.arrendatario}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                    />
                </Grid>
                <Grid item xs>
                    <ComboDestinos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'destinoProduccion',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Destino Producción'
                        api='auxiliares/destinoproduccion'
                        name='destinoProduccion'
                        nameKey='destinoProduccionId'
                        refresh={refresh}
                        value={parcela.destinoProduccion}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
                <Grid item xs>
                    <ComboDerechos
                        /*helperText={getOldValue(
                            old,
                            values,
                            'derechosViñedo',
                            'descripcion'
                        )}*/
                        fullWidth
                        //margin='none'
                        //variant='standard'
                        label='Estado Derechos'
                        api='auxiliares/derechosviñedo'
                        name='derechosViñedo'
                        nameKey='derechosViñedoId'
                        refresh={refresh}
                        value={parcela.derechosViñedo}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => `${option['descripcion']}`}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Text
                        //helperText={getOldValue(old, values, 'notas')}
                        fullWidth
                        multiline
                        rows={15}
                        name='notas'
                        label='Observaciones'
                        value={parcela.notas}
                        onChange={
                            handleChange &&
                            (values => handleChange(values, name, index))
                        }
                        editing={editing}
                    />
                </Grid>
            </Grid>
        </>
    );
};

const Parcelas = props => {
    const { values, editing, handleChange, refresh } = props;
    const [indexAjuste, setIndexAjuste] = useState(null);

    useEffect(() => {
        console.log('Calculo ajuste');
    }, [JSON.stringify(values.parcelas)]);

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={2}>
                <Grid item xs>
                    <DataGrid
                        allowSelect={'simple'}
                        changeSelectedItems={items => console.log(items)}
                        name='parcelas'
                        editing={editing}
                        rows={values.parcelas ? values.parcelas : []}
                        cols={(name, row, index) =>
                            cols(
                                name,
                                row,
                                index,
                                editing,
                                handleChange,
                                refresh,
                                values.tramite
                            )
                        }
                        onAdd={name => {
                            handleChange({}, name);
                        }}
                        onDelete={(name, index) =>
                            handleChange(undefined, name, (index + 1) * -1)
                        }
                        getId={item => {
                            if (item && item.parcelaTramite)
                                return item.parcelaTramite.id;
                            return null;
                        }}
                        //minHeight={350}
                        //maxHeight={350}
                        //maxWidth={1000}
                    />
                </Grid>
                {values.tramite.tipo.traspaso && (
                    <Grid item xs={8}>
                        <Grid container>
                            <Grid container spacing={2}>
                                <Grid item xs>
                                    <Divider
                                        style={{
                                            margin: '12px 12px 12px 12px'
                                        }}
                                    >
                                        <Chip
                                            label={
                                                'UNIFICAR / AJUSTAR PARCELAS'
                                            }
                                        />
                                    </Divider>
                                </Grid>
                            </Grid>
                            <ParcelaAjustada
                                index={indexAjuste}
                                name={'ajusteParcelas'}
                                values={values}
                                editing={editing}
                                handleChange={handleChange}
                                refresh={refresh}
                                parcela={
                                    values.ajusteParcelas &&
                                    values.ajusteParcelas[indexAjuste]
                                }
                            />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </form>
    );
};

export default Parcelas;
